const EVENT_VERSION = "1.0";

function hashText(text) {
  // Lightweight deterministic hash for tamper-evidence chain in browser runtime.
  let h = 2166136261;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return (h >>> 0).toString(16).padStart(8, "0");
}

function stableStringify(value) {
  if (value === null || typeof value !== "object") return JSON.stringify(value);
  if (Array.isArray(value)) return "[" + value.map(stableStringify).join(",") + "]";
  const keys = Object.keys(value).sort();
  return "{" + keys.map((k) => JSON.stringify(k) + ":" + stableStringify(value[k])).join(",") + "}";
}

export function isCriticalAuditAction(action = "") {
  const critical = new Set([
    "nc_draft",
    "ac_eval",
    "nc_generate",
    "decision_gate_reclassified",
    "decision_gate_override",
    "photo_analysis",
    "assistente_analysis",
    "ai_analysis",
    "gerou_pauta",
    "analisou_mudanca",
    "avaliou_clausula",
  ]);
  return critical.has(action);
}

export function buildAuditEvent(input = {}, previous = {}) {
  const occurredAt = input.timestamp || new Date().toISOString();
  const seq = Number(previous.seq || 0) + 1;
  const canonicalPayload = {
    event_version: EVENT_VERSION,
    occurred_at: occurredAt,
    seq,
    action: input.action || "unknown",
    module: input.module || "unknown",
    detail: input.detail || "",
    clause_ref: input.clauseRef || null,
    session_id: input.sessionId || null,
    entity_ref: input.entityRef || null,
    critical: isCriticalAuditAction(input.action),
    severity: input.severity || "info",
    actor_type: input.actorType || "user",
    prev_hash: previous.hash || null,
  };
  const payloadHash = hashText(stableStringify(canonicalPayload));
  const eventId = `evt_${occurredAt.replace(/\D/g, "").slice(0, 14)}_${seq}_${payloadHash}`;
  return {
    ...canonicalPayload,
    event_id: eventId,
    hash: hashText(`${canonicalPayload.prev_hash || "root"}:${payloadHash}`),
    payload_hash: payloadHash,
  };
}

export function verifyAuditEventChain(events = []) {
  for (let i = 0; i < events.length; i += 1) {
    const prev = i === 0 ? null : events[i - 1];
    const expected = buildAuditEvent(
      {
        timestamp: events[i].occurred_at,
        action: events[i].action,
        module: events[i].module,
        detail: events[i].detail,
        clauseRef: events[i].clause_ref,
        sessionId: events[i].session_id,
        entityRef: events[i].entity_ref,
        severity: events[i].severity,
        actorType: events[i].actor_type,
      },
      {
        seq: prev?.seq || 0,
        hash: prev?.hash || null,
      }
    );
    if (expected.hash !== events[i].hash || expected.payload_hash !== events[i].payload_hash) {
      return { ok: false, brokenAt: i, eventId: events[i].event_id };
    }
  }
  return { ok: true, brokenAt: -1, eventId: null };
}

